import {
    TextHelper,
    //SmallTextHelper,
    UrlHelper,
    //ArrayHelper
} from '../PrismicHelpers';

export const magazinePageHelper = (response) => {

    const magazinePageData = response.results[0].data;

    let dataToSend = {
        magazines_array: magazinePageData.magazines_array && magazinePageData.magazines_array.length > 0 && magazinePageData.magazines_array.map(magazine => {
            return {
                small_img: UrlHelper(magazine.small_img),
                url: TextHelper(magazine.url)
            }
        })
    };

    return dataToSend.magazines_array
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/MagazinePageHelpers.js